import * as React from 'react';
import './DashboardContent.scss';
import SwitchToClientsAccount from '../SwitchToClientsAccount';
import ManagePowerUsers from '../ManagePowerUsers';
import ChangePassword from '../ChangePassword';
import ManageECheck from '../ManageECheck';
import ManageCredits from '../ManageCredits';
import EcheckPaymentModel from 'src/model/echeckPayment.model';
import CreditModel from 'src/model/credit.model';
import UnlockUser from '../UnlockUser';

interface IDashboardContentProps {
  selected: 'switch' | 'info' |'manage' | 'password' | 'e-check' | 'credits' | 'unlock';
  selectedPayment: EcheckPaymentModel;
  selectedCredit: CreditModel;
  handlePaymentDetails: (payment: EcheckPaymentModel) => void;
  handleCreditDetails: (credit: CreditModel) => void;
}

export function DashboardContent(props: IDashboardContentProps) {
  function renderContent() {
    switch (props.selected) {
      case 'switch':
        return <SwitchToClientsAccount />;
      case 'info':
        return <SwitchToClientsAccount />;
      case 'manage':
        return <ManagePowerUsers />;
      case 'password':
        return <ChangePassword />;
      case 'e-check':
        return (
          <ManageECheck
            selectedPayment={props.selectedPayment}
            handlePaymentDetails={props.handlePaymentDetails}
          />
        );
      case 'credits':
        return (
          <ManageCredits
            selectedCredit={props.selectedCredit}
            handleCreditDetails={props.handleCreditDetails}
          />
        );
      case 'unlock':
        return <UnlockUser />;
      default:
        return null;
    }
  }

  return <div className="rp-dashboardcontent">{renderContent()}</div>;
}
